import endpoints from 'constants/endpoints';
import { GET_COMMISSIONS, IS_DOWNLOADING_REPORT } from 'constants/types';
import {
  safeAWSCallGet,
  safeAWSCallGetBlob,
  safeAWSCallPost,
  safePostCall
} from 'helpers/firebaseSetup';
import { showAlert, showAlertModal } from './site';
// import { wait } from '@testing-library/react';

// action creators
export const setIsDownloadingReport = payload => {
  return {
    type: IS_DOWNLOADING_REPORT,
    payload
  };
};

export const getCommissions =
  (carrier, carrierType) => async (dispatch, getState) => {
    const zohoId = getState().user.zohoData.id;
    const commissions = getState().commissions.commissions;

    if (!commissions[carrier] || commissions[carrier] === 'Error') {
      let response = await getCommissionsApiCall(zohoId, carrier, carrierType);
      dispatch({
        type: GET_COMMISSIONS,
        payload: { carrier, commissions: response }
      });
    }
  };

const getCommissionsApiCall = (agentId, carrierName, carrierType) =>
  safePostCall(endpoints.awsProxy.safePost, {
    endpoint: endpoints.zoho.getCommissions,
    agentId,
    carrierName,
    carrierType,
    isZohoRequest: true
  })
    .then(commissionsResponse => {
      if (commissionsResponse.data.details.output.includes('Error')) {
        return 'Error';
      } else return JSON.parse(`[${commissionsResponse.data.details.output}]`);
    })
    .catch(error => console.error(error));

export const downloadCommissionsData =
  (data, carriersOptions) => async dispatch => {
    dispatch(setIsDownloadingReport(true));
    dispatch(
      showAlert({ message: 'Running commission statement', code: 'info' })
    );

    const params = {
      carriers: (data.includeAllCarriers ? carriersOptions : data.carriers)
        .map(x => x.Callidus_Carrier_Names)
        .flat()
        .join(','),
      isAllCarriers: data.includeAllCarriers,
      agents: data.agents.map(x => x.id).join(','),
      agencies: data.agencies.map(x => x.id).join(','),
      periods: data.periods.map(x => x.value).join(','),
      includeOnlyActiveAgents: data.includeOnlyActiveAgents
    };

    try {
      const response = await safeAWSCallGetBlob(
        endpoints.aws.downloadCommissionsData,
        params,
        false
      );

      const downloadedFile = response?.data;
      const csvText =
        typeof downloadedFile === 'string'
          ? downloadedFile
          : typeof downloadedFile?.text === 'function'
          ? await downloadedFile.text()
          : null;

      if (csvText == null) {
        dispatch(setIsDownloadingReport(false));
        dispatch(
          showAlert({
            message:
              'Something went wrong downloading commissions data. Try again later.',
            code: 'error'
          })
        );
        return;
      }

      if (csvHasNoDataRows(csvText)) {
        dispatch(setIsDownloadingReport(false));
        dispatch(
          showAlertModal({
            title: 'No records found',
            message: 'There is no data available for the selected criteria.',
            size: 'small',
            hideFooter: true
          })
        );
        return;
      }

      dispatch(showAlert({ message: 'Downloading CSV data...', code: 'info' }));

      // generate date for file name
      let fileDate = new Date()
        .toISOString()
        .replace(/T/, '_') // replace T with a space
        .replace(/:/g, '_') // replace : with
        .replace(/\..+/, ''); // delete the dot and everything after

      if (window.ReactNativeWebView) {
        try {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: 'DOWNLOAD_CSV',
              csvData: csvText
            })
          );
        } catch (error) {
          console.error('Failed to send download to native app:', error);
        }
      } else {
        await downloadCSV(`Commission_Data_${fileDate}.csv`, csvText);
      }

      dispatch(
        showAlert({
          message: 'Data downloaded successfully!',
          code: 'success'
        })
      );

      dispatch(setIsDownloadingReport(false));
    } catch (error) {
      dispatch(setIsDownloadingReport(false));
      dispatch(
        showAlert({
          message:
            'Something went wrong downloading commissions data. Try again later.',
          code: 'error'
        })
      );
    }
  };

export const downloadBookOfBusinessData =
  (data, carriersOptions) => dispatch => {
    // Procedures
    const wait = t => {
      return new Promise(resolve => {
        setTimeout(() => resolve(), t);
      });
    };
    const showErrorAlert = msg => {
      dispatch(setIsDownloadingReport(false));
      dispatch(
        showAlert({
          message: msg,
          code: 'error'
        })
      );
    };
    const catchError = async err => {
      console.error(err);

      await dispatch(
        showAlert({
          message:
            'Something went wrong downloading commissions data. Try again later.',
          code: 'error'
        })
      );
      await wait(700);
      await dispatch(setIsDownloadingReport(false));
    };
    const userDonwloadCsv = async fileData => {
      // generate date for file name
      let fileDate = new Date()
        .toISOString()
        .replace(/T/, '_') // replace T with a space
        .replace(/:/g, '_') // replace : with
        .replace(/\..+/, ''); // delete the dot and everything after

      await downloadCSV(
        `Book_Of_Business_Data_${fileDate}.csv`,
        fileData
        // response.data.file
      );
      dispatch(
        showAlert({
          message: 'Data downloaded successfully!',
          code: 'success'
        })
      );
      dispatch(setIsDownloadingReport(false));
    };
    const showDownloadingAlert = () => {
      dispatch(setIsDownloadingReport(true));
      dispatch(
        showAlert({ message: 'Running books of business', code: 'info' })
      );
    };
    showDownloadingAlert();

    // prepares request params
    const body = {
      carriers: (data.includeAllCarriers ? carriersOptions : data.carriers)
        .map(x => x.Callidus_Carrier_Names)
        .flat(),
      agents: data.agents.map(x => x.id),
      agencies: data.agencies.map(x => x.id),
      activeFilter: data.activeFilter
    };
    const returnCsvDirectly = true;
    if (returnCsvDirectly) {
      safeAWSCallPost(endpoints.aws.downloadBookOfBusinessData, body, false)
        .then(async response => {
          const data =
            typeof response.data === 'string'
              ? await JSON.parse(response.data)
              : response.data;
          if (!data.ok) {
            showErrorAlert(data.message);
            return;
          }
          const build_csv_string = data.file.file.replaceAll('JUMPLINE', '\n');
          userDonwloadCsv(build_csv_string);
        })
        .catch(error => catchError(error));
    }
    if (!returnCsvDirectly) {
      // Functions
      const deleteFromServer = async (fileId, sub_files_indexes) => {
        await safeAWSCallGet(
          endpoints.aws.downloadBookOfBusinessDataDelete,
          {
            fileId,
            sub_files_indexes: sub_files_indexes.map(x => String(x)).join(',')
          },
          false
        );
      };
      const downLoadFilePieces = async (fileId, sub_files_indexes) => {
        const generateArrayOfRequests = (fileId, sub_files_indexes) => {
          let requests = [];
          for (let i = 0; i < sub_files_indexes.length; i++) {
            requests.push(
              safeAWSCallGet(
                endpoints.aws.downloadBookOfBusinessDataDownload,
                {
                  chunk_order: sub_files_indexes[i],
                  fileId
                },
                false
              )
            );
          }
          return requests;
        };
        const groupRequests = async (requests, membersInEachGroup) => {
          const request_groups = [];
          let group_count = 0;
          let group_member_count = 0;
          for (let i = 0; i < requests.length; i++) {
            const one_request = requests[i];
            if (group_member_count === 0) {
              request_groups[group_count] = [];
            }
            request_groups[group_count].push(one_request);
            group_member_count++;
            if (group_member_count === membersInEachGroup) {
              group_count++;
              group_member_count = 0;
            }
          }
          return request_groups;
        };
        const checkAllResponsesAreOk = responses_array => {
          const textIsNotEmpty = element =>
            element?.data.file !== '' &&
            element?.data.file !== null &&
            element?.data.file !== undefined;
          const responseIsOk = element => element?.data?.ok;
          return (
            responses_array.every(responseIsOk) &&
            responses_array.every(textIsNotEmpty)
          );
        };
        const makeRequestByGroups = async request_groups => {
          const responses = [];
          for (let i = 0; i < request_groups.length; i++) {
            const one_group = request_groups[i];
            const group_responses = await Promise.all(one_group);
            const allResponsesAreOk = checkAllResponsesAreOk(group_responses);
            if (!allResponsesAreOk)
              throw new Error('Problem downloading the file');
            await wait(500);
            responses.push(group_responses);
          }
          return responses.flat().map(x => x.data.file);
        };
        // Prepares array of requests/promises
        const requests = generateArrayOfRequests(fileId, sub_files_indexes);
        // Groups requests batches of 5
        const request_groups = await groupRequests(requests, 5);
        // Makes requests in batches of 5
        const csv_text_chunks = await makeRequestByGroups(request_groups);
        // rturns text
        return csv_text_chunks;
      };
      const buildAndDonwloadCsv = async chunks => {
        const re_build_csv_string = chunks.join('');
        userDonwloadCsv(re_build_csv_string);
      };
      const parseResponseData = givenData => {
        const parsedGivenData =
          typeof givenData === 'string' ? JSON.parse(givenData) : givenData;
        if (parsedGivenData.sub_files_indexes) {
          parsedGivenData['sub_files_indexes'] =
            parsedGivenData.sub_files_indexes
              .split(',')
              .map(x => Number(x.trim()));
        }
        if (parsedGivenData.ok) {
          parsedGivenData['ok'] = parsedGivenData.ok === 'true' ? true : false;
        }
        return parsedGivenData;
      };
      // kept outside the promise chain so the catch can clean up the server file
      let responseData = null;
      // Starts the request
      safeAWSCallPost(endpoints.aws.downloadBookOfBusinessData, body, false)
        .then(async response => {
          // Parses the response
          responseData = parseResponseData(response.data);

          // Error message if EC2 times out
          const firstRequesTimedOut = String(responseData).includes(
            '504 Gateway Time-out'
          );
          if (firstRequesTimedOut) {
            showErrorAlert('Report took too long to respond, try again.');
            return;
          }

          // Error message if response is not ok
          if (!responseData.ok) {
            showErrorAlert(responseData.message);
            return;
          }

          // Downloads pieces from server
          const responses = await downLoadFilePieces(
            responseData.fileId,
            responseData.sub_files_indexes
          );

          // Download csv to user
          await buildAndDonwloadCsv(responses);

          // Deletes file from server
          await deleteFromServer(
            responseData.fileId,
            responseData.sub_files_indexes
          );
        })
        .catch(async error => {
          catchError(error);
          if (!responseData?.fileId) return;
          await deleteFromServer(
            responseData.fileId,
            responseData.sub_files_indexes
          );
        });
    }
  };

export const getLastUpdatedateBOB = async () => {
  return safeAWSCallGet(endpoints.aws.BookOfBussinessLastUpdateDate)
    .then(async response => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(error => {
      console.error(error);
    });
};

function csvHasNoDataRows(csvText) {
  if (csvText == null || String(csvText).trim() === '') return true;
  const lines = String(csvText)
    .replace(/\r\n/g, '\n')
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean);
  return lines.length <= 1;
}

async function downloadCSV(filename, data) {
  var blob = new Blob([data]);
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = await filename;
  link.click();
}
